/* eslint-disable consistent-return */
import React, {
  useCallback, useEffect, useRef, useState,
} from 'react';
import './StyleNotification.scss';
import { useDispatch, useSelector } from 'react-redux';
import { CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { MessageIcon } from '../../assets/NavBarIcons';
import { RootState } from '../../redux/rootState';
import {
  getFoNotifications,
  getFoNotificationsSuccess,
} from './redux/dashboardSlice';
import { Notification, NotificationsData } from './utils/TypeDashboard';
import EndPoints from '../../Routes/EndPoints';
import { sendEquipmentType } from '../InventoryManagement/utils/constants';

function ScreenFoNotification({ handleClose }: { handleClose: () => void }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const containerRef = useRef<HTMLDivElement>(null);
  const {
    foNotifications, isFoNotificationsLoading,
  } = useSelector((state: RootState) => state.dashboardReducer);

  const [page, setPage] = useState(1);
  const [data, setData] = useState<Notification[]>([]);
  const [isFetching, setIsFetching] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  const handleScroll = useCallback(() => {
    const container = containerRef.current;
    if (!container || isFetching || !hasMore) return;

    const { scrollTop, scrollHeight, clientHeight } = container;
    if (scrollTop + clientHeight >= scrollHeight - 10) {
      setIsFetching(true);
      setPage((prev) => prev + 1);
    }
  }, [isFetching, hasMore]);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    container.addEventListener('scroll', handleScroll);
    return () => container.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    if (page === 1) return; // initial data already loaded from header
    dispatch(getFoNotifications({ pageNumber: page, pageSize: 10, IsFoNotification: true }));
  }, [page]);

  useEffect(() => {
    setIsFetching(false);
    if (!foNotifications?.Data) return;

    let appendData = [];
    if (page === 1) {
      appendData = foNotifications?.Data;
      setData(appendData);
    } else {
      appendData = [...data, ...(foNotifications?.Data || [])];
      setData(appendData);
    }

    if (appendData.length >= foNotifications?.TotalRecords) {
      setHasMore(false);
    }
  }, [foNotifications]);

  useEffect(() => {
    dispatch(getFoNotificationsSuccess({} as NotificationsData));
    dispatch(getFoNotifications({ pageNumber: 1, pageSize: 10, IsFoNotification: true }));
  }, []);
  // useEffect(() => () => {
  //   dispatch(getFoNotificationsSuccess({} as NotificationsData));
  //   dispatch(getFoNotifications({ pageNumber: 1, pageSize: 10, IsFoNotification: true }));
  // }, []);

  const handleNavigate = (type: string, reqId: string, role: number) => {
    if (type === 'Request_From_FO') {
      navigate(`${EndPoints.TEST_EQUIPMENT_REQUEST_FORM}/${reqId}/${role}`);
    } else {
      navigate(`/${EndPoints.SEND_EQUIPMENT_SCREEN}/${sendEquipmentType.SEND_EQUIPMENT}/${reqId}`);
    }
    handleClose();
  };

  return (
    <div className="dropdown-content" ref={containerRef}>
      <div className="div-style_title">
        Requests from FO
        {isFoNotificationsLoading && !isFetching && <CircularProgress size={20} thickness={4} sx={{ color: '#ffffff !important' }} />}
      </div>
      <ul className="ul-style">
        <li>
          {data?.map((item) => (
            <div className="div2 pointCursor" onClick={() => handleNavigate(item?.TypeOfRequest, item?.ReqId, item?.RoleId)}>
              <div>
                <MessageIcon />
              </div>
              {item?.TypeOfRequest === 'Request_From_FO' ? (
                <div className="profile">
                  A Request
                  {' '}
                  <span>{`(${item?.ReqId})`}</span>
                  {' '}
                  is sent by the Front Office for review
                </div>
              ) : (
                <div className="profile">
                  Job
                  {' '}
                  <span>{item?.JobOrder}</span>
                  {' '}
                  is scheduled, you need to ship the equipment from Request
                  {' '}
                  <span>{`(${item?.ReqId})`}</span>
                </div>
              )}
            </div>
          ))}
        </li>
      </ul>
      {isFetching && (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '12px 0',
        }}
      >
        <CircularProgress size={28} thickness={4} sx={{ color: '#00A751 !important' }} />
      </div>
      )}
    </div>
  );
}

export default ScreenFoNotification;
